import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders } from './../../../../../Containers/Config/index';
import { GET_ATTRIBUTES, GET_ATTRIBUTES_SUCCESS, GET_ATTRIBUTES_ERROR } from './../../../actionType';
import apiCall from '../../../apiCall';
import { Constant } from '../../../../../Containers/Helpers/constant';

function* getAttributes({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/attributes`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        pageSize: Constant?.TABLE_PAGE_SIZE,
        ...payload.urlParam,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_ATTRIBUTES_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_ATTRIBUTES_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_ATTRIBUTES_ERROR, payload: error });
  }
}

export function* watchGetAttributes() {
  yield takeEvery(GET_ATTRIBUTES, getAttributes);
}

function* getAttributesSaga() {
  yield all([fork(watchGetAttributes)]);
}

export default getAttributesSaga;
